export function isLinkAttribution(attribution) {
    return attribution.discriminator === 'LinkAttribution';
}
export function isPersonAttribution(attribution) {
    return attribution.discriminator === 'PersonAttribution';
}
//# sourceMappingURL=types.js.map